import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { BannerComponent, MapComponent } from 'common/components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { getHarvestedFlag } from 'common/utils';
import { ACTIVITY_TYPES } from 'common/constants';
import './index.css';

class FieldWrapper extends PureComponent {
  _showingFields = () => {
    const { cachedFields, field, selectedCrop, match } = this.props;
    let fieldArray = (field && field.fields) || cachedFields;
    // don't filter fields for seeding activity
    if (selectedCrop && match.params.type !== ACTIVITY_TYPES.SEEDING) {
      fieldArray = fieldArray.filter(
        field =>
          field.crops &&
          (selectedCrop.name === null // when the empty field is selected)
            ? field.crops.length === 0
            : field.crops.length > 0 &&
              field.crops.some(
                fieldCrop =>
                  fieldCrop.crop.name === selectedCrop.name &&
                  fieldCrop.crop.variety === selectedCrop.variety
              ))
      );
    }

    return fieldArray.map(item => ({
      geojson: item.geojson ? JSON.parse(item.geojson) : null,
      paths: item.shape,
      plantedArea: item.plantedArea,
      title: item.name,
      size: item.size,
      harvested: getHarvestedFlag(item.crops) || false,
      disabled: item.disabled || false,
      crops: item.crops || [],
      location: item.location || null,
    }));
  };

  _showingStorages = () => {
    const { storages, cachedStorages, selectedCrop } = this.props;
    let showingStorages = storages || cachedStorages;
    if (selectedCrop) {
      showingStorages = showingStorages.filter(
        storage =>
          storage.crop &&
          storage.crop.name === selectedCrop.name &&
          storage.crop.variety === selectedCrop.variety
      );
    }

    return showingStorages;
  };

  render() {
    const {
      browser,
      children,
      gestureHandling,
      ignoreMapUpdate,
      mapOptions,
      nav,
      showMapFlag,
      showFields,
      showStorages,
      theme,
      useMaxZoomService,
      withCurrentLocation,
      storage,
      showStorageMarkers,
      usePreservedLocation,
    } = this.props;
    const wrapperCSS = classnames(
      'field-wrapper__wrapper columns is-gapless',
      showMapFlag && 'field-wrapper--mapactive',
      theme && theme.map(css => `columns--${css}`).join(' ')
    );

    const asideContentCSS = classnames(
      'column__inner field-wrapper__aside__content',
      {
        'field-wrapper__aside__content--invisible':
          browser.is.mobile && showMapFlag,
      }
    );

    return (
      <div className={wrapperCSS}>
        <aside className="column is-one-third is-gapless field-wrapper__aside">
          {nav && (
            <BannerComponent
              theme={['static', 'strong', 'large', 'mobile-fixed']}
            >
              {nav}
            </BannerComponent>
          )}
          <div className={asideContentCSS}>{children}</div>
        </aside>
        <MapComponent
          gestureHandling={gestureHandling}
          ignoreMapUpdate={ignoreMapUpdate}
          usePreservedLocation={usePreservedLocation}
          polygons={this._showingFields()}
          showFields={showFields}
          showStorages={showStorages}
          showStorageMarkers={showStorageMarkers}
          storage={storage}
          storages={this._showingStorages()}
          useMaxZoomService={useMaxZoomService}
          withCurrentLocation={withCurrentLocation}
          {...mapOptions}
        />
      </div>
    );
  }
}

FieldWrapper.propTypes = {
  browser: PropTypes.object,
  cachedFields: PropTypes.arrayOf(PropTypes.object),
  cachedStorages: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
  field: PropTypes.object,
  gestureHandling: PropTypes.oneOf(['none', 'cooperative', 'greedy']),
  ignoreMapUpdate: PropTypes.bool,
  mapOptions: PropTypes.object,
  match: PropTypes.object.isRequired,
  nav: PropTypes.element,
  selectedCrop: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  showFields: PropTypes.bool,
  showMapFlag: PropTypes.bool,
  showStorages: PropTypes.bool,
  showStorageMarkers: PropTypes.bool,
  storages: PropTypes.arrayOf(PropTypes.object),
  storage: PropTypes.object,
  theme: PropTypes.array,
  useMaxZoomService: PropTypes.bool,
  usePreservedLocation: PropTypes.bool,
  withCurrentLocation: PropTypes.bool,
};
FieldWrapper.defaultProps = {
  cachedFields: [],
  cachedStorages: [],
  gestureHandling: 'greedy',
  ignoreMapUpdate: false,
  polygonClickable: false,
  selectedCrop: null,
  showFields: false,
  showStorages: false,
  showStorageMarkers: false,
  useMaxZoomService: false,
  usePreservedLocation: false,
  withCurrentLocation: true,
};

const mapState = ({ browser, map, form }) => ({
  browser,
  cachedFields: map.fields,
  cachedStorages: map.storages,
  selectedCrop:
    form.activityform &&
    form.activityform.values &&
    form.activityform.values.crop &&
    JSON.parse(form.activityform.values.crop),
});

const enchance = compose(
  connect(mapState),
  withRouter
);

export default enchance(FieldWrapper);



// WEBPACK FOOTER //
// ./src/common/components/FieldWrapper/index.js